import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {OrderProps, OrderStatus} from '../types';
import ordersKeys from './orders-keys';
import {useQueryClient} from 'react-query';

interface GroupBy<T> {
  [key: string]: T[];
}

const useUpdateOrder = () => {
  const {getQueries, setData} = useQueryHelpers();
  const queryClient = useQueryClient();

  const updateOrder = (data: OrderProps, status: OrderStatus) => {
    const orderId = data.id;
    const groupByOrders = getQueries<GroupBy<OrderProps>>(ordersKeys.all());

    groupByOrders.forEach((ordersQuery) => {
      const [queryKey, queryData] = ordersQuery;

      if (!queryData) return;

      const orders = queryData.data;

      Object.keys(orders).map(
        (key) =>
          (orders[key] = orders[key].filter((order) => order.id !== orderId)),
      );

      orders[status] = [...orders[status], data];

      queryData.data = orders;

      queryClient.setQueryData(queryKey, queryData);
    });

    setData(ordersKeys.details(orderId), data);
  };

  return updateOrder;
};

export default useUpdateOrder;
